import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactElement } from 'react'

import style from './IconButton.module.css'

type DefaultButtonPropsType = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

type PropsType = {
  callback: Function
  children: ReactElement
  title: string
} & DefaultButtonPropsType

export const IconButton = ({ callback, title, children, ...props }: PropsType) => {
  return (
    <button onClick={() => callback()} className={style['info-button']} title={title} {...props}>
      {children}
    </button>
  )
}
